"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleContentType = exports.BubbleType = exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType[InputType["SHORT_TEXT"] = 0] = "SHORT_TEXT";
    InputType[InputType["LONG_TEXT"] = 1] = "LONG_TEXT";
    InputType[InputType["PHONE"] = 2] = "PHONE";
    InputType[InputType["EMAIL"] = 3] = "EMAIL";
    InputType[InputType["WEBSITE"] = 4] = "WEBSITE";
    InputType[InputType["YES_OR_NO"] = 5] = "YES_OR_NO";
    InputType[InputType["SINGLE_SELECT"] = 6] = "SINGLE_SELECT";
    InputType[InputType["MULTIPLE_SELECT"] = 7] = "MULTIPLE_SELECT";
    InputType[InputType["FILE_UPLOAD"] = 8] = "FILE_UPLOAD";
    InputType[InputType["RATING"] = 9] = "RATING";
    InputType[InputType["IMAGE_SELECT"] = 10] = "IMAGE_SELECT";
    InputType[InputType["DATE_PICKER"] = 11] = "DATE_PICKER";
    InputType[InputType["SHARE"] = 12] = "SHARE";
    InputType[InputType["NO_INPUT"] = 13] = "NO_INPUT";
    InputType[InputType["PAYMENT"] = 14] = "PAYMENT";
    InputType[InputType["REDIRECTION"] = 15] = "REDIRECTION";
    InputType[InputType["NUMBER"] = 16] = "NUMBER";
    InputType[InputType["SCALE"] = 17] = "SCALE";
})(InputType = exports.InputType || (exports.InputType = {}));
var BubbleType;
(function (BubbleType) {
    BubbleType[BubbleType["QUESTION"] = 0] = "QUESTION";
    BubbleType[BubbleType["REPLY"] = 1] = "REPLY";
})(BubbleType = exports.BubbleType || (exports.BubbleType = {}));
var BubbleContentType;
(function (BubbleContentType) {
    BubbleContentType[BubbleContentType["TEXT"] = 0] = "TEXT";
    BubbleContentType[BubbleContentType["IMAGE"] = 1] = "IMAGE";
    BubbleContentType[BubbleContentType["VIDEO"] = 2] = "VIDEO";
    BubbleContentType[BubbleContentType["GIF"] = 3] = "GIF";
    BubbleContentType[BubbleContentType["IFRAME"] = 4] = "IFRAME";
})(BubbleContentType = exports.BubbleContentType || (exports.BubbleContentType = {}));
__exportStar(require("./conditions"), exports);
__exportStar(require("./chatbotStats"), exports);
__exportStar(require("./results"), exports);
__exportStar(require("./inputs"), exports);
__exportStar(require("./connectors"), exports);
__exportStar(require("./v2/results"), exports);
__exportStar(require("./v2/typebot"), exports);
__exportStar(require("./v2/publicTypebot"), exports);
__exportStar(require("./v2/dto"), exports);
__exportStar(require("./theme"), exports);
//# sourceMappingURL=index.js.map